import Vue from 'vue'
import { Toast, ImagePreview, Lazyload } from 'vant'

// 将所有 loading Toast 设置为背景不可点击 (2.2.10 版本开始支持)
Toast.setDefaultOptions('loading', { forbidClick: true })
Vue.use(Toast)

Vue.prototype.$loading = function(message = '加载中...', duration = 0) {
  return Toast.loading({
    // 默认为0，表示持续展示不消失
    duration,
    message,
    // 是否禁止背景点击
    forbidClick: true
  })
}

Vue.prototype.$hideLoading = function() {
  return Toast.clear()
}

/**
 * @options
 * loading  加载时的图片  string
 * error  错误时的图片 string
 * preload  预加载高度的比例
 * lazyComponent  是否能懒加载模块
 * filter  图片 URL 过滤

 * @use
 * v-lazy: 将v-lazy指令的值设置为你需要懒加载的图片
 * */
Vue.use(Lazyload, {
  lazyComponent: true,
  error: require('../assets/images/default-image.png')
})

/**
 * @params
 * images: [
 'https://img.yzcdn.cn/vant/apple-1.jpg'
 ],
 startPosition: 1,
 onClose() {}
 */
Vue.prototype.$imagePreview = ({ ...params }) => {
  return ImagePreview(params)
}
